import {combineReducers} from 'redux';
import PagesReducer from '../containers/pages/reducer';
import UsersReducer from '../containers/users/reducer';
import RolesReducer from '../containers/roles/reducer';
import ConfigurationReducer from '../containers/configuration/reducer';
import BlocksReducer from '../containers/blocks/reducer';
import SitesReducer from '../containers/sites/reducer';
import LocationsReducer from '../containers/locations/reducer';
import {reducer as reduxFormReducer} from 'redux-form';
import {reducer as toastrReducer} from 'react-redux-toastr';
import {routerReducer} from 'react-router-redux';
import authReducer from '../containers/auth/reducer';
import sideBarReducer from '../containers/layout/reducer';
import GridReducer from '../containers/grid/reducer';
import PagePickerReducer from '../containers/page-picker/reducer';
import StaffReducer from '../containers/staff/reducer';
import PageBuilderReducer from '../containers/builder/reducer';
import LabelsReducer from '../containers/labels/reducer';
import ImagesReducer from '../containers/images/reducer';
import SectionsSettings from '../containers/pages/settings/reducer';
import MenusReducer from '../containers/menus/reducer';
import LanguagesReducer from '../containers/languages/reducer';
import ReviewsReducer from '../containers/reviews/reducer';
import TaxonomyReducer from '../containers/taxonomy/reducer';
import OverviewReducer from '../containers/overview/reducer';
import PageBuilderSectionPopupReducer from '../containers/builder/sections/reducer';
import PageBuilderMetaPopupReducer from '../containers/builder/meta/reducer';
import PageTemplatesReducer from '../containers/templates/reducer';
import RedirectsReducer from '../containers/redirects/reducer';
import TagsReducer from '../containers/tags/reducer';
import FaqsReducer from '../containers/faqs/reducer';
import MyAccountReducer from '../containers/myaccount/reducer';
import WebinarsReducer from '../containers/webinars/reducer';
import SectionReducer from '../containers/builder/sections/reducers/index';

const rootReducer = combineReducers({
    grid: GridReducer,
    pagePicker: PagePickerReducer,
    pages: PagesReducer,
    pageBuilder: PageBuilderReducer,
    users: UsersReducer,
    roles: RolesReducer,
    configuration: ConfigurationReducer,
    blocks: BlocksReducer,
    sites: SitesReducer,
    taxonomy: TaxonomyReducer,
    locations: LocationsReducer,
    labels: LabelsReducer,
    menus: MenusReducer,
    staff: StaffReducer,
    form: reduxFormReducer,
    toastr: toastrReducer,
    router: routerReducer,
    auth: authReducer,
    layout: sideBarReducer,
    images: ImagesReducer,
    sectionsSettings: SectionsSettings,
    languages: LanguagesReducer,
    reviews: ReviewsReducer,
    overview: OverviewReducer,
    pageBuilderSectionPopup: PageBuilderSectionPopupReducer,
    pageBuilderMetaPopup: PageBuilderMetaPopupReducer,
    template: PageTemplatesReducer,
    redirects: RedirectsReducer,
    tags: TagsReducer,
    faqs: FaqsReducer,
    myaccount: MyAccountReducer,
    webinars: WebinarsReducer,
    sections: SectionReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js